import { render } from "./IconPencilAlt.vue?vue&type=template&id=79d20f04"
import script from "./IconPencilAlt.vue?vue&type=script&lang=js"
export * from "./IconPencilAlt.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__